import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { Flexbox } from "../../shared/components";

export const LensPreviewFormContainer = styled(Flexbox)`
    /* flex, not height: 100% — the body is a flex column whose height can grow past its floor. */
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;

    width: 589px;
    padding-top: 24px;

    background: ${Colors.WHITE};
    border-radius: 6px;
`;

export const lensPreviewFormHeader = css`
    padding: 0 24px;

    > * {
        margin: 0;
    }
`;

export const LensPreviewFormTitle = styled.h2`
    padding-bottom: 12px;

    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const ButtonsContainer = styled(Flexbox)`
    gap: 12px;
    justify-content: flex-end;

    height: 56px;
    padding: 12px 16px 12px 0;

    background: ${Colors.Gray.V50};
    border-radius: 0 0 6px 6px;
`;

export const lensPreviewContent = css`
    /* Grows to fill the card so the button row stays flush at the bottom, and past it when a
       validation message appears — the two panels above cannot shrink below their own content. */
    flex: 1;
    flex-direction: column;
    gap: var(--spacing-md);

    min-height: 316px;
    padding: 21px 24px 24px;
`;

export const lensPreviewValidationMessage = css`
    padding-left: var(--spacing-lg);
`;

export const LensPreviewText = styled.p`
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: #858d94;

    border-radius: 6px;
`;
